export enum PushNotificationRecurringTypeEnum {
  Daily = "Daily",
  Weekly = "Weekly",
  Monthly = "Monthly",
}
